export enum WEBGL_CONTENT_LAYER_Z {
  // fallow-ignore-next-line unused-enum-member
  PLANE_ABOVE = 0.1,
  // fallow-ignore-next-line unused-enum-member
  BG_ABOVE = 0.2,
  MODEL = 0.3,
  // fallow-ignore-next-line unused-enum-member
  PLANE_ABOVE_MODEL = 0.4
}

export enum WEBGL_UNIVERSE_RENDER_ORDER {
  GRAFFITI = 1,
  SHADOWS = 2,
  MIST = 3,
  DUST = 4
}

export const WEBGL_UNIVERSE_MONITOR_POS = { x: 0, y: 1.55, z: 0 }

export const WEBGL_UNIVERSE_CAMERA = {
  INTRO: {
    position: { x: 0, y: 1.5, z: 0.45 },
    rotation: { x: 0, y: 0, z: 0 }
  },
  DEFAULT: {
    position: { x: 0, y: 0.8, z: 5 },
    rotation: { x: 0, y: 0, z: 0 }
  }
}

const WEBGL_UNIVERSE_LOOK = {
  INTRO: {
    position: { x: 0, y: WEBGL_UNIVERSE_MONITOR_POS.y, z: 0 }
  },
  DEFAULT: {
    position: { x: 0, y: WEBGL_UNIVERSE_MONITOR_POS.y, z: 0 }
  }
}

export const WEBGL_UNIVERSE_WHEEL_BOUNDARIES = {
  lerp: {
    min: -3, max: 0
  },
  percentage: {
    min: 2, max: WEBGL_UNIVERSE_CAMERA.DEFAULT.position.z
  }
}

export const WEBGL_CAMERA_CONFIG = {
  DEFAULT: {
    config: {
      fov: 0.1,
      aspect: 0,
      near: 0.1,
      far: 100
    },
    position: { x: 0, y: 0, z: 2 },
    rotation: { x: 0, y: 0, z: 0 },
    lookAt: { x: 0, y: 0, z: 0 }
  },
  UNIVERSE: {
    config: {
      fov: 55,
      aspect: 0,
      near: 0.1,
      far: 100
    },
    position: WEBGL_UNIVERSE_CAMERA.INTRO.position,
    rotation: WEBGL_UNIVERSE_CAMERA.INTRO.rotation,
    lookAt: WEBGL_UNIVERSE_LOOK.INTRO.position
  }
}

export const COLLABHUB_ROLES = [
  '3D Generalist',
  '3D Motion Design',
  'AI',
  'Colorist',
  'Compositor VFX',
  'Creative',
  'Creative Technologist',
  'Director',
  'DOP',
  'Event Manager',
  'Illustrator',
  'Location Scout',
  'Motion Graphic Designer',
  'New Media innovation',
  'Photo Retoucher',
  'Photographer',
  'Project Manager',
  'Set Designer',
  'Sound Design',
  'Technical Artist',
  'Unity Dev',
  'Unreal Dev',
  'UX/UI Designer',
  'Video Editor',
  'Videomaker',
  'Web Dev'
]
